import { c as _c } from "react/compiler-runtime";
import { StyledIconTab, IconTabIconContainer } from './styles';
import { type IconTabProps } from './types';
import { ICON_TAB_CLASS_NAME } from './classnames';
import { forwardRef } from 'react';
const IconTab = forwardRef<HTMLDivElement, IconTabProps>((t0, ref) => {
  const $ = _c(13);
  let disabled;
  let icon;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      icon,
      disabled,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = disabled;
    $[2] = icon;
    $[3] = props;
    $[4] = size;
  } else {
    disabled = $[1];
    icon = $[2];
    props = $[3];
    size = $[4];
  }
  let t1;
  if ($[5] !== icon) {
    t1 = <IconTabIconContainer>{icon}</IconTabIconContainer>;
    $[5] = icon;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== disabled || $[8] !== props || $[9] !== ref || $[10] !== size || $[11] !== t1) {
    t2 = <StyledIconTab label={t1} size={size} disableFocusRipple={true} disabled={disabled} className={ICON_TAB_CLASS_NAME} {...props} ref={ref} />;
    $[7] = disabled;
    $[8] = props;
    $[9] = ref;
    $[10] = size;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
});
export default IconTab;
export { IconTab };